'use strict'
import Vue from 'vue'
import { createStore } from 'vuex'

const constante = require('./constantes')

// Vue.use(Vuex)

const store = createStore({
  state: {
    primaryColor: localStorage.primaryColor || '#408080',
    accentColor: localStorage.accentColor || '#408080',
    darkenColor: localStorage.darkenColor || '#408080',
    backgroundColor: localStorage.backgroundColor || '#ffffff',
    fontColor: localStorage.fontColor || '#000000',
    image: localStorage.image || '',
    izquierdoLogin: localStorage.izquierdoLogin || 'offset-l3',
    imagenFondo: localStorage.imagenFondo || '',
    imagenFondoIn: localStorage.imagenFondoIn || '',
    hideNav:'0',
    barra: false,
    isAdmin: false,
    permisos:''
  },
  mutations: {
    theming: (state, empresa) => {
      state.primaryColor = empresa.primaryColor
      state.accentColor = empresa.accentColor
      state.darkenColor = empresa.darkenColor
      state.backgroundColor = empresa.backgroundColor
      state.fontColor = empresa.fontColor
      state.image = empresa.image
      state.imagenFondo = empresa.imagenFondo
      state.imagenFondoIn = empresa.imagenFondoIn
      state.izquierdoLogin = empresa.izquierdoLogin
      state.hideNav = empresa.hideNav
      localStorage.setItem('primaryColor', empresa.primaryColor)
      localStorage.setItem('accentColor', empresa.accentColor)
      localStorage.setItem('darkenColor', empresa.darkenColor)
      localStorage.setItem('backgroundColor', empresa.backgroundColor)
      localStorage.setItem('fontColor', empresa.fontColor)
      localStorage.setItem('image', empresa.image)
      localStorage.setItem('imagenFondo', empresa.imagenFondo)
      localStorage.setItem('imagenFondoIn', empresa.imagenFondoIn)
      localStorage.setItem('izquierdoLogin', empresa.izquierdoLogin)
      localStorage.setItem('hideNav', empresa.hideNav)
    },
    ponerBarra(state){
      state.barra=true
    },
    quitarBarra(state){
      state.barra=false
    },
    setAdmin(state, value){
      state.isAdmin = value
    },
    setPermisos(state, value){
      state.permisos = value
    }
  }
})

export default store
